import { useEffect, useState } from 'react';
import { formatDate, FORMAT } from '../../../../lib/date';
import { ReactComponent as CloseSvg } from '../../../../assets/svg/closeCircle.svg';
import { ReactComponent as LoadingSvg } from '../../../../assets/svg/loading-half-status.svg';
import request from '../../../../lib/request';

const CreateDialog = ({ dialogRef, closeDialog, isDialogOpen, refresh }) => {
  const [date, setDate] = useState('');
  const [measurement, setMeasurement] = useState({
    Waist: 0,
    Hips: 0,
    'R-Thigh': 0,
    'L-Thigh': 0,
    'R-Arm': 0,
    'L-Arm': 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isDialogOpen) {
      setDate(formatDate(new Date()));
    }
  }, [isDialogOpen]);

  const resetState = () => {
    setMeasurement({
      Waist: 0,
      Hips: 0,
      'R-Thigh': 0,
      'L-Thigh': 0,
      'R-Arm': 0,
      'L-Arm': 0,
    });
  };

  const handleMeasurementChange = (key) => (e) => {
    if (!isNaN(Number(e.target.value))) {
      setMeasurement((prev) => ({
        ...prev,
        [key]: e.target.value,
      }));
    }
  };

  const handleSubmit = async () => {
    if (Object.values(measurement).every((value) => value === 0)) {
      return;
    }

    try {
      setLoading(true);

      const { result } = await request.post('/log/measurement', {
        waist: Number(measurement.Waist),
        hips: Number(measurement.Hips),
        rThigh: Number(measurement['R-Thigh']),
        lThigh: Number(measurement['L-Thigh']),
        rArm: Number(measurement['R-Arm']),
        lArm: Number(measurement['L-Arm']),
        date,
        time: formatDate(new Date(), FORMAT.HOURMIN),
      });

      if (result) {
        await refresh();
        resetState();
        closeDialog();
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  const handleCancel = () => {
    resetState();
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
      onCancel={handleCancel}
    >
      <div className='bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl p-4 flex flex-col text-white overflow-y-hidden'>
        <div className='flex justify-end mb-6'>
          <button onClick={handleCancel}>
            <CloseSvg />
          </button>
        </div>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>Date</label>
          <input
            type='date'
            max={formatDate(new Date())}
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className='rounded-full px-2 py-1 bg-tertiary  text-white'
          />
        </div>
        <div className='grid grid-cols-2 gap-2 mb-2'>
          {Object.entries(measurement).map(([key, value]) => (
            <div
              key={key}
              className='flex items-center justify-between'
            >
              <label className='text-white font-semibold'>{key}</label>
              <div className='text-white flex items-center gap-2'>
                <div className='flex items-center'>
                  <input
                    type='number'
                    name={key}
                    value={value}
                    onChange={handleMeasurementChange(key)}
                    className='rounded-full px-2 py-1 bg-tertiary text-white text-center max-w-20'
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className='flex justify-end items-center font-bold mb-4'>
          unit: cm
        </div>
        <div className='flex justify-between items-center'>
          <button
            className='rounded-full w-full py-2 bg-accent font-bold text-black'
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <div className='flex justify-center items-center'>
                <LoadingSvg className='animate-spin' />
              </div>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default CreateDialog;
